export const mobileMenu = () => {
  const mobileMenu = document.getElementById("menuMobile");
  return mobileMenu?.offsetParent ? mobileMenu : null;
};
